import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import LoanMappingCreateModalUI from './LoanMappingCreateModalUI.js'

class LoanMappingCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // sourceValue
      sourceValue: '',
      sourceValueError: null,
      // mappedValue
      mappedValue: '',
      mappedValueError: null,
      // form events
      submitted: false,
    }
  }

  render() {
    return (
      <LoanMappingCreateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // sourceValue
        sourceValue={this.state.sourceValue}
        onSourceValueChange={(event) => { this.setState({ sourceValue: event.target.value }) }}
        sourceValueError={this.state.sourceValueError}
        setSourceValueError={(error) => { this.setState({ sourceValueError: error }) }}
        // mappedValue
        mappedValue={this.state.mappedValue}
        onMappedValueChange={(event) => { this.setState({ mappedValue: event.target.value }) }}
        mappedValueError={this.state.mappedValueError}
        setMappedValueError={(error) => { this.setState({ mappedValueError: error }) }}
        // modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
      />
    )
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/mappingGroups/security_cover`,
      this.onSubmitCallback, {
      sourceValue: this.state.sourceValue,
      mappedValue: this.state.mappedValue,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch (error.fieldName) {
        case 'sourceValue':
          this.setState({ sourceValueError: error.message })
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

    if (this.state.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          sourceValue: '',
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }
}

export default withRouter(LoanMappingCreateModalSF)
